(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
(function () {
  const section = document.querySelector('[data-money-format]');
  const moneyFormat = section ? section.dataset.moneyFormat : '${{amount}}';

  function formatMoney(cents) {
    return moneyFormat.replace(/\{\{[\s]*amount[\s]*\}\}/, (cents / 100).toFixed(2));
  }

  function cartChange(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function applyUpdate(cart, key, quantity, itemEl) {
    if (quantity === 0) {
      itemEl.remove();
    } else {
      var updated = cart.items.find(function (i) { return i.key === key; });
      if (updated) {
        var priceEl = itemEl.querySelector('[data-line-price]');
        if (priceEl) priceEl.textContent = formatMoney(updated.final_line_price);
      }
    }
    var subtotalEl = document.getElementById('cart-subtotal');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (cart.item_count === 0) window.location.reload();
  }

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('.cart-item__qty-btn');
    if (qtyBtn) {
      var itemEl = qtyBtn.closest('.cart-item');
      var input = itemEl.querySelector('.cart-item__qty-input');
      var newQty = Math.max(0, parseInt(input.value, 10) + parseInt(qtyBtn.dataset.dir, 10));
      input.value = newQty;
      var key = input.dataset.itemKey;
      cartChange(key, newQty).then(function (cart) { applyUpdate(cart, key, newQty, itemEl); });
      return;
    }

    var removeBtn = e.target.closest('.cart-item__remove');
    if (removeBtn) {
      var key = removeBtn.dataset.key;
      var itemEl = removeBtn.closest('.cart-item');
      cartChange(key, 0).then(function (cart) { applyUpdate(cart, key, 0, itemEl); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const hamburger = document.querySelector('[data-hamburger]');
  const drawer = document.querySelector('[data-nav-drawer]');
  const overlay = document.querySelector('[data-nav-overlay]');
  const closeBtn = document.querySelector('[data-drawer-close]');

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    hamburger.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    hamburger.focus();
  }

  hamburger.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["live"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var list = document.querySelector('.live__list');
    if (!list) return;
    var items = Array.from(list.querySelectorAll('.live__show'));
    items.sort(function (a, b) {
      return a.dataset.date.localeCompare(b.dataset.date);
    });
    items.forEach(function (item) { list.appendChild(item); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var section = document.querySelector('.pdp');
    if (!section) return;

    var moneyFormat = section.dataset.moneyFormat || '${{amount}}';
    var variants = JSON.parse(document.getElementById('pdp-variants-data').textContent);
    var images = JSON.parse(document.getElementById('pdp-images-data').textContent);
    var inventoryData = JSON.parse(document.getElementById('pdp-inventory-data').textContent);

    var variantIdInput = document.getElementById('pdp-variant-id');
    var priceEl = document.getElementById('pdp-price');
    var atcBtn = document.getElementById('pdp-atc');
    var mainImg = document.getElementById('pdp-main-img');
    var optionGroups = section.querySelectorAll('.pdp__option-btns');
    var dots = section.querySelectorAll('.pdp__dot');

    var currentImageIndex = 0;

    var selectedOptions = Array.from(optionGroups).map(function (group) {
      var active = group.querySelector('.is-selected');
      return active ? active.dataset.value : null;
    });

    function formatMoney(cents) {
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
    }

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
      });
    }

    function isValueAvailable(groupIndex, value) {
      return variants.some(function (v) {
        return v.options[groupIndex] === value && v.available;
      });
    }

    function refreshSoldOutStates() {
      optionGroups.forEach(function (group, groupIndex) {
        group.querySelectorAll('.pdp__opt-btn').forEach(function (btn) {
          var soldOut = !isValueAvailable(groupIndex, btn.dataset.value);
          btn.classList.toggle('is-sold-out', soldOut);
        });
      });
    }

    function updateQtyMax(variant) {
      if (!variant) { qtyInput.removeAttribute('max'); return; }
      var inv = inventoryData[String(variant.id)];
      if (inv && inv.policy === 'deny') {
        qtyInput.max = inv.qty;
        if (parseInt(qtyInput.value, 10) > inv.qty) qtyInput.value = Math.max(1, inv.qty);
      } else {
        qtyInput.removeAttribute('max');
      }
    }

    function updateUI(variant) {
      if (!variant) {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Unavailable';
        return;
      }
      variantIdInput.value = variant.id;
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += '<span class="pdp__price--compare">' + formatMoney(variant.compare_at_price) + '</span>';
      }
      html += '<span class="pdp__price--current">' + formatMoney(variant.price) + '</span>';
      priceEl.innerHTML = html;
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      updateQtyMax(variant);
    }

    optionGroups.forEach(function (group, groupIndex) {
      group.querySelectorAll('.pdp__opt-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-sold-out')) return;
          selectedOptions[groupIndex] = btn.dataset.value;
          group.querySelectorAll('.pdp__opt-btn').forEach(function (b) {
            b.classList.toggle('is-selected', b === btn);
          });
          updateUI(findVariant());
        });
      });
    });

    refreshSoldOutStates();

    /* ── Quantity ── */
    var qtyInput = section.querySelector('.pdp__qty-input');

    function clampQty() {
      var val = parseInt(qtyInput.value, 10) || 1;
      var max = qtyInput.max ? parseInt(qtyInput.max, 10) : Infinity;
      qtyInput.value = Math.min(max, Math.max(1, val));
    }

    qtyInput.addEventListener('input', clampQty);
    qtyInput.addEventListener('change', clampQty);

    section.querySelectorAll('.pdp__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var max = qtyInput.max ? parseInt(qtyInput.max, 10) : Infinity;
        qtyInput.value = Math.min(max, Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.dataset.dir, 10)));
      });
    });

    updateQtyMax(findVariant());

    /* ── Image gallery ── */
    function goToImage(index) {
      if (!mainImg || images.length === 0) return;
      currentImageIndex = (index + images.length) % images.length;
      var img = images[currentImageIndex];
      mainImg.src = img.src;
      mainImg.srcset = img.srcset || '';
      mainImg.alt = img.alt;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentImageIndex);
      });
    }

    var prevBtn = section.querySelector('.pdp__arrow--prev');
    var nextBtn = section.querySelector('.pdp__arrow--next');
    if (prevBtn) prevBtn.addEventListener('click', function () { goToImage(currentImageIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToImage(currentImageIndex + 1); });

    /* ── Swipe ── */
    var gallery = section.querySelector('.pdp__gallery');
    var touchStartX = 0;
    if (gallery) {
      gallery.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      gallery.addEventListener('touchend', function (e) {
        var delta = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(delta) > 40) goToImage(currentImageIndex + (delta < 0 ? 1 : -1));
      }, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signup-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DISMISSED_KEY = 'hara_popup_dismissed';
    var BREVO_URL = 'https://b81cfa9c.sibforms.com/serve/MUIFAEcaEk-690nSMCvsjMeWw3PnLv3yNp4XZBMZFhx_9o9hbpSm4Fb0ctfqEMSaoRhwEZW7GrIuTIy0GJHX30xOdVH7jfHQoMogIVFiD-8z7DarWV3O45ZGhF5bFzhRVTP8Yg3G_mkpH7UvgST2l38CdKWW9QDj-gN63BsGwgVLisk3n03veP3_ud-waIEixsXWnOSnEUTzafDV';

    var overlay = document.getElementById('signup-popup-overlay');
    if (!overlay) return;

    var closeBtn = document.getElementById('popup-close');
    var form = document.getElementById('popup-form');
    var successMsg = document.getElementById('popup-success');
    var fieldError = document.getElementById('popup-field-error');
    var delay = parseInt(overlay.dataset.delay, 10) || 5000;

    function show() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
    }

    function dismiss() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      try { localStorage.setItem(DISMISSED_KEY, '1'); } catch (e) {}
    }

    function isDismissed() {
      try { return !!localStorage.getItem(DISMISSED_KEY); } catch (e) { return false; }
    }

    if (!isDismissed()) {
      setTimeout(show, delay);
    }

    closeBtn.addEventListener('click', dismiss);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) dismiss();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) dismiss();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var email = form.querySelector('[name="EMAIL"]').value.trim();
      var city = form.querySelector('[name="CITY"]').value.trim();

      if (!email || !city) {
        fieldError.textContent = 'Please fill in all fields.';
        return;
      }

      fieldError.textContent = '';

      var data = new FormData(form);

      fetch(BREVO_URL, { method: 'POST', body: data, mode: 'no-cors' }).catch(function () {});

      form.style.display = 'none';
      successMsg.style.display = 'block';
      try { localStorage.setItem(DISMISSED_KEY, '1'); } catch (e) {}
      setTimeout(dismiss, 3000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
